import React, { useEffect } from 'react';
import setSeo from '../utils/seo.js';
import Contact from '../components/Contact.jsx';
import PageHero3D from '../components/PageHero3D.jsx';

/**
 * ContactPage wraps the contact form and details in its own route. A page
 * hero with a particle background and descriptive heading introduces the
 * contact section.
 */
const ContactPage = () => {
  useEffect(() => {
    setSeo({
      title: 'Contact Us | Aakeeo Technologies - Book Your Free Consultation',
      description: "Book a free 30-minute consultation to discuss CRM and AI automation solutions tailored to your business. Get expert guidance on SuiteCRM implementation and workflow automation.",
      keywords: ['contact Aakeeo', 'CRM consultation', 'free consultation', 'business automation consultation', 'SuiteCRM expert'],
      canonical: window.location.href,
      og: {
        title: 'Contact Aakeeo Technologies - Free CRM & AI Consultation',
        description: 'Schedule your free consultation with our CRM and AI automation experts. Let us help transform your business processes.',
        type: 'website'
      }
    });
  }, []);

  return (
    <div className="contact-page">
      <PageHero3D 
        title={"Let's map your workflow and plan the build"}
        subtitle={"Tell us about your process; we'll suggest the simplest path to results."}
        accent="#e63946"
      />
      <Contact />
    </div>
  );
};

export default ContactPage;
